import { Button } from "@fanduel/formation-react-components";
import { ArrowsChevronRight } from "@fanduel/formation-react-icons";
import { ScheduledGameT } from "@/utils/hooks/useScheduledGamesFilter";
import Leaders from "./Leaders";
import LiveGameStatLine from "./LiveAndPostGameStatLine";
import styles from "../nflMatchupCard.module.scss";

interface LiveGameExpansionContentProps {
  game: ScheduledGameT;
  isTooSmallForFullNames: boolean;
}

const LiveGameExpansionContent = ({
  game,
  isTooSmallForFullNames,
}: LiveGameExpansionContentProps) => {
  const homeStats = game.homeTeam?.stats ?? {};
  const awayStats = game.awayTeam?.stats ?? {};
  return (
    <div className={styles.expansionContent}>
      {game.odds?.url && (
        <a href={game.odds.url} target="_blank" rel="noreferrer">
          <Button
            label="Explore the Event in Sportsbook"
            onClick={() => {}}
            size="small"
            variant="tertiary"
            fill={true}
            iconRight={<ArrowsChevronRight />}
          />
        </a>
      )}

      <div className={styles.expansionCard}>
        <div className={styles.statsContainer}>
          <LiveGameStatLine
            statName="Passing Yards"
            homeStat={homeStats.passingYards ?? 0}
            awayStat={awayStats.passingYards ?? 0}
            homeColor={game.homeTeam?.primaryColor}
            awayColor={game.awayTeam?.primaryColor}
          />
          <LiveGameStatLine
            statName="Rushing Yards"
            homeStat={homeStats.rushingYards ?? 0}
            awayStat={awayStats.rushingYards ?? 0}
            homeColor={game.homeTeam?.primaryColor}
            awayColor={game.awayTeam?.primaryColor}
          />
          <LiveGameStatLine
            statName="Interceptions Thrown"
            homeStat={homeStats.interceptionsThrown ?? 0}
            awayStat={awayStats.interceptionsThrown ?? 0}
            homeColor={game.homeTeam?.primaryColor}
            awayColor={game.awayTeam?.primaryColor}
          />
          <LiveGameStatLine
            statName="Fumbles Forced"
            homeStat={homeStats.fumblesForced ?? 0}
            awayStat={awayStats.fumblesForced ?? 0}
            homeColor={game.homeTeam?.primaryColor}
            awayColor={game.awayTeam?.primaryColor}
          />
        </div>
        <Leaders
          homeTeam={game.homeTeam}
          awayTeam={game.awayTeam}
          isTooSmallForFullNames={isTooSmallForFullNames}
        />
      </div>
    </div>
  );
};

export default LiveGameExpansionContent;
